// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.note-text[data-v-e060f300] {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #464646;\n  margin-bottom: 16px;\n  margin-left: 8px;\n  line-height: 22px;\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  margin-top: 16px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
